<script lang="ts" setup>
</script>

<template>
  <svg
    width="23"
    height="19"
    viewBox="0 0 23 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.7714 0.25708H2.25715C1.12573 0.25708 0.200012 1.18279 0.200012 2.31422V14.6571C0.200012 15.7885 1.12573 16.7142 2.25715 16.7142H7.40001V18.7714H15.6286V16.7142H20.7714C21.9029 16.7142 22.8286 15.7885 22.8286 14.6571V2.31422C22.8286 1.18279 21.9029 0.25708 20.7714 0.25708ZM20.7714 14.6571H2.25715V2.31422H20.7714V14.6571ZM18.7143 5.39994H7.40001V7.45708H18.7143V5.39994ZM18.7143 9.51422H7.40001V11.5714H18.7143V9.51422ZM6.37144 5.39994H4.3143V7.45708H6.37144V5.39994ZM6.37144 9.51422H4.3143V11.5714H6.37144V9.51422Z"
      fill="#7B90FF"
    />
  </svg>
</template>
